import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import ProductOne from "../product/ProductOne";
import data from "../../data/productcamasirsulari.json";
import Spacer2 from "../common/Spacer2";
import Spacer3 from "../common/Spacer3";

function ProductSimilarCamasirsulari() {
  const { t } = useTranslation();

  return (
    <>
      <section class="product mt--100">
        <div class="container">
          <div class="section-title text-center">
            <div class="section-title__triangle">
              <img
                src="assets/images/favicons/favicon-32x32.webp"
                alt="icon"
                aria-label="icon"
              />
            </div>
            <h5 className="section-title__tagline">
              {t("SEYMEN KİMYA")}
            </h5>
            <h2 class="section-title__title">{t("ÇAMAŞIR SULARI")}</h2>
            <Spacer3 />
          </div>

          <div class="nisoz-owl__dots nisoz-owl__carousel ">
            <Row>
              {data.map((productcamasirsulari) => {
                const { picture, id, nav, price } = productcamasirsulari;
                const title = t(productcamasirsulari.title);

                return (
                  <Col md={4} key={id} className="text-center mb-5">
                    <ProductOne
                      picture={picture}
                      title={title}
                      price={price}
                      nav={nav}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductSimilarCamasirsulari;
